import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageSectionHeading from '../../PageSectionHeading';
import CommunityContactCard from '../../CommunityContactCard';
import { colors } from '../../../styles';

const styles = css`
  padding: 45px 0;
  background-color: ${colors.neutral};
  position: relative;
  z-index: 2;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .DecorativePhoto {
    display: none;
    @media (min-width: 1600px) {
      display: flex;
      width: 20%;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
  .CommunityContactCards_wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    @media (min-width: 1600px) {
      width: calc(80% - 90px);
    }
  }
`;


function CommunityContactCards({ content, communities }) {
  return (
    <section className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} underdog />
      }
      <div className="container-fluid pt-4">
        <div className="row justify-content-between">
          <div className="DecorativePhoto" style={{ backgroundImage: `url(${buildThumbnailUrl(get(content[0], 'image.contentUrl'), { width: 700, height: 1600 })})` }} />
          <div className="CommunityContactCards_wrapper">
            {
              orderBy(communities, 'name').filter(community => community.status === 'Active').map(community => {
                return (
                  <CommunityContactCard community={community} key={community._id} />
                );
              })
            }
          </div>
        </div>
      </div>
    </section>
  );
}

CommunityContactCards.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  communities: 'all',
})(CommunityContactCards);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/CommunityContactCards.section.js